import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ElementRef,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, ActivationEnd, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ACLService } from '@delon/acl';

@Component({
  selector: 'sendDetail',
  templateUrl: './tiktokList.component.html',
  styles: [],
})
export class SendDetailTiktokListComponent implements OnInit {
  constructor(
    private router: Router,
    private cdr: ChangeDetectorRef,
    private el: ElementRef,
    private aclService: ACLService,
    private route: ActivatedRoute
  ) {}

  // 自定义组件名
  static NAME = 'icc-msg-sendDetail';

  queryParams = {
    msgTypes: '',
    id: '0',
    isDetail: false,
    batchName: '',
    sentCount: 0,
    validTickets: 0,
    successCount: 0,
    failCount: 0,
    unknownCount: 0,
    moCount: 0,
    shardTime: null,
  };
  selectedMenu = '';

  private router$: Subscription;
  menus: any[] = [];
  mode = 'inline';

  title: string;

  to(item: any) {
    if (this.queryParams.isDetail) {
      this.router.navigate([`/msgRecord/sendRecord/detail/${item.key}`], {
        queryParams: this.queryParams,
      });
    } else {
      this.router.navigateByUrl(`/msgRecord/sendDetail/tiktok/${item.key}`);
    }
  }

  back() {
    this.router.navigateByUrl(`/msgRecord/sendRecord`);
  }

  private setActive() {
    const key = this.router.url.substr(this.router.url.lastIndexOf('/') + 1);
    this.menus.forEach((i) => {
      if (i.key === key) {
        i.selected = i.key === key;
        this.selectedMenu = i.key;
      } else {
        i.selected = i.key === this.menus[0].key;
        this.selectedMenu = i.key;
      }
    });
    this.title = this.menus.find((w) => w.selected).title;
  }

  ngOnInit() {
    if (this.aclService.canAbility('sendDetail.tiktok.broadcast')) {
      this.menus.push({
        inx: 1,
        key: 'groupSend',
        title: '广播消息',
      });
    }
    if (this.aclService.canAbility('sendDetail.tiktok.message')) {
      this.menus.push({
        inx: 2,
        key: 'message',
        title: '私信回复',
      });
    }
    if (this.aclService.canAbility('sendDetail.tiktok.comment')) {
      this.menus.push({
        inx: 3,
        key: 'comment',
        title: '评论回复',
      });
    }

    // 获取参数， 使用 queryParams
    this.queryParams.id = this.route.snapshot.queryParams.id || '0';
    this.queryParams.shardTime =
      this.route.snapshot.queryParams.shardTime || null;
    this.queryParams.msgTypes =
      this.route.snapshot.queryParams.msgTypes || this.menus;
    this.queryParams.isDetail =
      this.route.snapshot.queryParams.isDetail || false;
    this.queryParams.batchName =
      this.route.snapshot.queryParams.batchName || '';

    this.queryParams.sentCount = this.route.snapshot.queryParams.sentCount || 0;
    this.queryParams.validTickets =
      this.route.snapshot.queryParams.validTickets || 0;
    this.queryParams.successCount =
      this.route.snapshot.queryParams.successCount || 0;
    this.queryParams.failCount = this.route.snapshot.queryParams.failCount || 0;
    this.queryParams.unknownCount =
      this.route.snapshot.queryParams.unknownCount || 0;
    this.queryParams.moCount = this.route.snapshot.queryParams.moCount || 0;
    if (this.queryParams.isDetail) {
      this.menus = JSON.parse(this.queryParams.msgTypes);
    }

    this.router$ = this.router.events
      .pipe(filter((e) => e instanceof ActivationEnd))
      .subscribe(() => this.setActive());

    if (this.queryParams.isDetail) {
      this.router.navigate(
        [
          '/msgRecord/sendRecord/detail/' +
            JSON.parse(this.queryParams.msgTypes)[0].key,
        ],
        {
          queryParams: this.queryParams,
        }
      );
    } else {
      this.router.navigateByUrl(
        '/msgRecord/sendDetail/tiktok/' + this.menus[0].key
      );
    }
  }
}
